import classNames from 'classnames';
import './button-group.css';
import { ReactNode } from 'react';

type ButtonGroupProps = {
  float?: boolean;
  children?: ReactNode;
  className?: string;
};

function ButtonGroup({ float = false, children, className }: ButtonGroupProps) {
  return (
    <div className={classNames('btn-group flex', { 'btn-group-stretched': float }, className)}>
      {children}
    </div>
  );
}

export default ButtonGroup;
